var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGestaoPapelComercial(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "gestao-papel-comercial",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 171 171",
    style: {
      enableBackground: "new 0 0 171 171"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#DD5100;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "gestao-papel-comercial_1_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M50.4,88.8h23.3V65.1H50.4V88.8z M58.4,73h7.4v7.8h-7.4V73z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.7,
    y: 112.5,
    className: "st0",
    width: 22.9,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50.4,
    y: 96.8,
    className: "st0",
    width: 23.3,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50.4,
    y: 112.5,
    className: "st0",
    width: 23.3,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.7,
    y: 64.9,
    className: "st0",
    width: 22.9,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.7,
    y: 96.8,
    className: "st0",
    width: 22.9,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50.4,
    y: 50.3,
    className: "st0",
    width: 54.2,
    height: 8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M128.5,70.3v54.2c0,2.2-1.8,4-4,4s-4-1.8-4-4V34.4h-86v90.1c0,6.6,5.4,12,12,12h78.1c6.6,0,12-5.4,12-12 V70.3H128.5z M46.4,128.4c-2.2,0-4-1.8-4-4v-82h70.1v82.1c0,1.4,0.2,2.7,0.7,4H46.4V128.4z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.7,
    y: 80.8,
    className: "st0",
    width: 22.9,
    height: 8
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGestaoPapelComercial);
export default __webpack_public_path__ + "static/media/gestao-papel-comercial.bacc72258a8dbe71eec1659a79df2c00.svg";
export { ForwardRef as ReactComponent };